// Scripted timeline-replay sequence — drives severity and request selection
// over a few seconds so a viewer sees Bloom + KATLAS responding to evolving conditions.
//
// Each step is a {at_ms, severity, flow, mode, label} marker. The runner is
// intentionally tiny — `useTimelineReplay` in App.js consumes this list.

export const TIMELINE_STEPS = [
  { at_ms: 0,     severity: 1, flow: "low",         mode: "auto", label: "Routine — low severity" },
  { at_ms: 3500,  severity: 2, flow: "low",         mode: "auto", label: "Conditions tighten" },
  { at_ms: 7000,  severity: 3, flow: "escalating",  mode: "auto", label: "Escalation — human review threshold reached" },
  { at_ms: 10500, severity: 4, flow: "sensitive",   mode: "auto", label: "Critical — sensitive cross-boundary request" },
  { at_ms: 14000, severity: 4, flow: "sensitive",   mode: "auto", label: "Decision record finalised", end: true },
];

export const TIMELINE_DURATION_MS = TIMELINE_STEPS[TIMELINE_STEPS.length - 1].at_ms;
